module.exports = __webpack_public_path__ + "static/fonts/Gotham-Ultra.b8d72cb.otf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Gotham-Ultra.otf
// module id = eUED
// module chunks = 1